<template>
  <div>
    <div class="ls_drawer_main_content">
      <Form ref="formData" :model="formData" :rules="rules">
        <!-- APPLIED || ORDER DATE -->
        <Row type="flex" justify="space-between" class="code-row-bg">
          <Col :xs="24" :sm="24" :md="10">
            <FormItem prop="applied">
              <div class="switch-custom">
                <i-switch v-model="formData.applied"></i-switch>
                <span>{{schema.applied.label}}</span>
              </div>

            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="10">
            <FormItem
              prop="order_date"
              label-position="right"
            >
<!--              <template v-slot:label>-->
<!--                <span style="margin-left: 50px">{{-->
<!--                  schema.order_date.label-->
<!--                }}</span>-->
<!--              </template>-->

              <DatePicker
                :clearable="false"
                type="datetime"
                :placeholder="schema.order_date.label"
                format="yyyy-MM-dd HH:mm"
                :value="formData.order_date"
                @on-change="setOrderDate"
                style="float: right;"
              ></DatePicker>
            </FormItem>
          </Col>
        </Row>

        <!-- NUMBER -->
        <FormItem :label="schema.number.label" prop="number">
          <Input v-model="formData.number" :placeholder="schema.number.label"/>
        </FormItem>

        <!-- ACCOUNT (FROM) -->
        <FormItem
          label="Со счета"
          prop="account"
        >
          <Select v-model="formData.account" filterable>
            <Option
              v-for="item in formSelectOptions.account"
              :value="item.id"
              :key="item.id"
            >{{ item.name }}</Option>
          </Select>
        </FormItem>


        <!-- ACCOUNT (TO) -->
        <FormItem
          label="На счет"
          prop="counterpart.id"
        >
          <Select v-model="formData.counterpart.id" filterable>
            <Option
              v-for="item in formSelectOptions.account"
              :value="item.id"
              :key="item.id"
            >{{ item.name }}</Option>
          </Select>
        </FormItem>

        <!-- SUM -->
        <FormItem prop="sum" :label="schema.sum.label">
          <InputNumber
            :min="0"
            v-model="formData.sum"
            :placeholder="schema.sum.label"
            style="width: 100%"
          ></InputNumber>
        </FormItem>

        <!-- DESCRIPTION -->
        <FormItem prop="description" :label="schema.description.label">
          <Input
            type="textarea"
            v-model="formData.description"
            :placeholder="schema.description.label"
          />
        </FormItem>
      </Form>
    </div>
    <div class="ls_drawer_footer">
      <Button style="margin-right: 8px" type="error" @click="cancelAction()"><Icon type="md-close"/></Button>
      <Button
        type="info"
        @click="saveAction()"
        :disabled="disabledSaveButton"
      ><Icon type="md-checkmark"/>
      </Button>
    </div>

    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
  import {base_url} from "../../http.js";
  import {BaseFormData} from "../../base/base_form_v2.js";

  // const CORRECT_ACC_BALANCE = 8;

  let base = BaseFormData();

  base.data = function () {
    return {
      loading: true,
      baseRules: {},
      excludeFieldsRules: [],
      extraRules: {
        "counterpart.id": [
          {
            required: true,
            // type: "number",
            // message: this.schema[field].help_text,
            message: "Выберите корректное значение поля",
            trigger: "change"
          }
        ]
      },
      validForm: false,
      isChanged: false,

      formData: {
        number: "",
        applied: '',
        sum: "",
        description: "",
        account: "",
        order_date: "",

        counterpart: {
          type: "",
          id: null
        }
      },

      formDefaultInitData: {
        type: "coming",
        number: "",
        applied: true,
        sum: 0,
        description: "",
        account: "",
        category: "",
        order_date: new Date(),
        counterpart: {
          type: "account",
          id: null
        }
      },

      formSelectOptions: {
        account: [],
        // supplier: [],
        // customer: [],
        // user: [],

        // category_outgoing: [],
        // category_coming: []
      },
      CORRECT_ACC_BALANCE: 8
    };
  };
  base.computed.counterpart_type = function () {
    return this.formData.type === "coming" ? "Отправитель" : "Получатель";
  };

  base.methods.setOrderDate = function (date_str, date2) {
    // console.log(date1);
    // console.log(date2);
    this.formData.order_date = date_str;
  };

  // Справочники
  base.methods.getAccounts = function () {
    const url = base_url + "/options/accounts/";
    this.$http
      .get(url)
      .then(result => {
        this.formSelectOptions.account = result.data.results;
      })
  };
  base.methods.save = function () {
    let url = base_url + "/money_order/transfer/";
    this.loading = true;
    this.$http
      .post(url, this.formData)
      .then(response => {
        this.$Message.success("Успешно сохранено");
        this.$emit("click_cancel");
        this.$emit("reload_table");
      })
            .finally(() => {
              this.loading = false;
            });
  };

  // base.methods.getSuppliers = function() {
  //   const url = base_url + "/options/suppliers/";
  //   this.$http
  //     .get(url)
  //     .then(result => {
  //       this.formSelectOptions.supplier = result.data.results;
  //     })
  //     .catch(error => {
  //       this.$Message.error("Ошибка получения списка поставщиков");
  //     });
  // };
  // base.methods.getCustomers = function() {
  //   const url = base_url + "/options/customers/";
  //   this.$http
  //     .get(url)
  //     .then(result => {
  //       this.formSelectOptions.customer = result.data.results;
  //     })
  //     .catch(error => {
  //       this.$Message.error("Ошибка получения списка покупателей");
  //     });
  // };
  // base.methods.getUsers = function() {
  //   const url = base_url + "/options/users/";
  //   this.$http
  //     .get(url)
  //     .then(result => {
  //       this.formSelectOptions.user = result.data.results;
  //     })
  //     .catch(error => {
  //       this.$Message.error("Ошибка получения списка сотрудников");
  //     });
  // };
  // base.methods.getCategoryOutgoing = function() {
  //   const url = base_url + "/options/payment_category/outgoing/";
  //   this.$http
  //     .get(url)
  //     .then(result => {
  //       this.formSelectOptions.category_outgoing = result.data.results;
  //     })
  //     .catch(error => {
  //       this.$Message.error("Ошибка получения списка сотрудников");
  //     });
  // };
  // base.methods.getCategoryComing = function() {
  //   const url = base_url + "/options/payment_category/coming/";
  //   this.$http
  //     .get(url)
  //     .then(result => {
  //       this.formSelectOptions.category_coming = result.data.results;
  //     })
  //     .catch(error => {
  //       this.$Message.error("Ошибка получения списка сотрудников");
  //     });
  // };

  base.mounted = function () {
    this.getAccounts();
    // this.getSuppliers();
    // this.getCustomers();
    // this.getUsers();
    // this.getCategoryOutgoing();
    // this.getCategoryComing();

    this.formData = this.formDefaultInitData;

    // if (this.$route.query["type"] === "coming") {
    //   this.formData.type = "coming";
    // } else if (this.$route.query["type"] === "outgoing") {
    //   this.formData.type = "outgoing";
    // }
  };
  base.created = function () {
    this.loading = false;
  };

  base.watch.type = function (to, from) {
    this.formData.category = "";
  };

  base.watch["formData.counterpart.id"] = function (to, from) {
    this.validateForm();
    this.isChanged = true;
  };

  // base.watch['formData.account'] = function (to, from) {
  //   console.log(11);
  // };

  export default base;
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/apps/money_order/moneyOrderFormTransfer.vue